import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Card,
	CardContent,
	ListItem,
	Grid,
	Typography
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	root: {
		paddingTop: 0,
		paddingBottom: 0
	},

	card: {
		width: "100%",
		borderRadius: 0,
		borderBottom: "1px solid #dedede"
	},

	cardContent: {
		paddingBottom: `${2*theme.spacing(1)}px !important`
	},

	clickable: {
		"&:hover": {
			backgroundColor: theme.palette.grey[200]
		}
	},

	selected: {
		backgroundColor: theme.palette.grey[200]
	},

	topicInfo: {
		paddingLeft: theme.spacing(.5)
	},

	topicName: {
		lineHeight: 1.2
	},

	chevronContainer: {
		display: "flex",
		justifyContent: "flex-end",
		paddingTop: "0.1rem"
	},

	chevron: {
		color: theme.palette.text.secondary
	},

	listItem: {
		cursor: "pointer"
	}
}));

function TrendingTopicListItem(props) {
	const numFormatter = new Intl.NumberFormat("en-US", {maximumFractionDigits: 0});

	let classes = styles(),
		{topic, topicNumber, className, clickHandler, selected, national} = props;

	return (
		<ListItem
			disableGutters
			classes={{root: classes.root}}
			className={`${clickHandler ? classes.listItem : ""} ${className}`}
			onClick={clickHandler ? () => clickHandler(topic) : null}>
			<Card
				elevation={0}
				className={`${classes.card} ${selected === true ? classes.selected : ""}`}>
				<CardContent className={`${classes.cardContent} ${clickHandler ? classes.clickable : ""}`}>
					<Grid container>
						<Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
							<Typography color="textSecondary">{topicNumber}</Typography>
						</Grid>
						<Grid item xs={10} sm={10} md={10} lg={10} xl={10} className={classes.topicInfo}>
							<Typography className={classes.topicName}>{topic.name.replace(/\|/ig, "/")}</Typography>
							<Typography variant="caption" color="textSecondary">
								{national ?
									<span>~{numFormatter.format(topic.total*100)} people discussing</span>
									:
									<span>{topic.posts} posts &middot; {topic.authors} people</span>
								}
							</Typography>
						</Grid>
						{clickHandler ?
							<Grid item xs={1} sm={1} md={1} lg={1} xl={1} className={classes.chevronContainer}>
								<FontAwesomeIcon icon={["far", "arrow-right"]} className={classes.chevron} title="chevron" />
							</Grid> : null
						}
					</Grid>
				</CardContent>
			</Card>
		</ListItem>
	);
}

TrendingTopicListItem.propTypes = {
	topic: PropTypes.object.isRequired,
	topicNumber: PropTypes.number,
	className: PropTypes.string,
	clickHandler: PropTypes.func,
	selected: PropTypes.bool,
	national: PropTypes.bool
};

export default TrendingTopicListItem;
